module.exports = __webpack_public_path__ + "assets/img/landing-rtb-hero.b6608f4c.webp";